import React from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Hero from './Hero'
import HomeAbout from '../HomeAbout'
import HomePlatform from '../HomePlatform'
import HomeAgriculture from '../HomeAgriculture'
import WhyChoose from '../WhyChoose'
import HomeProcess from '../HomeProcess'
import HomeIndustries from '../HomeIndustries'



const Home = () => {
  return (
    <>
      <Header/>

           <Hero/>
           <HomeAbout/>
           <HomeAgriculture/>
           <HomePlatform/>
           <WhyChoose/>
           <HomeProcess/>
           <HomeIndustries/>
            
      <Footer/>
    </>
  )
}

export default Home
